<div class="head1 mb-5 d-none d-lg-block d-xl-block">
    <div class="container animated fadeIn">
        <div class="col-lg-12">
            <div class="row">
                <div class="col-lg-4">
                    <div class="row">
                        <a href="https://api.whatsapp.com/send?phone=+57 323 4902185" class="btnWht" target="_blank"><i class="fa fa-whatsapp fa-lg"></i></a>
                        <h5 class="hd1 ml-2"> WhatsApp 323 4902185</h5>
                    </div>
                </div>
                <div class="col-lg-8">
                    <a class="redes" href="https://www.facebook.com/torreonmarket.colombia" target="blank"><i class="fa fa-facebook fa-lg" aria-hidden="true"></i></a>
                    <a class="redes" href="https://www.youtube.com/channel/UCMhrKPXZXlqmfUKSyXMIlsw" target="blank"><i class="fa fa-youtube fa-lg" aria-hidden="true"></i></a>
                    <a class="redes" href="https://twitter.com/torreonmarket" target="blank"><i class="fa fa-twitter fa-lg" aria-hidden="true"></i></a>
                    <a class="redes" href="https://www.instagram.com/torreon.market" target="blank"><i class="fa fa-instagram fa-lg" aria-hidden="true"></i></a>
                </div>
            </div>
        </div>
        <div class="col-lg-12">
            <div class="row">
                <div class="col-lg-5">
                    <div class="row">
                        <img [routerLink]="['/home']" routerLinkActive="router-link-active" src="../../../assets/img/logoTorreon.png" class="img-fluid mt-4 ml-5" alt="Responsive image" width="250">
                    </div>
                </div>
                <div class="col-lg-7 mt-5 sch">
                    <form id="buscar" [formGroup]="searchForm" class="form-inline" (ngSubmit)="OnSearch(searchForm.value.palabra)">
                        <input type="text" value="" class="form-control" placeholder="Ej...colágeno, artritis, huesos" formControlName="palabra" autocomplete="off" />
                        <button type="submit" class="btn btn-light"><i class="fa fa-search" aria-hidden="true"></i></button>
                        <button class="car" [routerLink]="['/solicitudes']" routerLinkActive="router-link-active">
                            <i class="fa fa-shopping-cart fa-lg" aria-hidden="true"></i>
                            <span class="badge badge-warning intermitente">{{pedidos}}</span>
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div>
        <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarNav">
                <ul class="navbar-nav">
                    <li class="nav-item active">
                        <a class="nav-link" [routerLink]="['/home']">Inicio <span class="sr-only">(current)</span></a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [routerLink]="['/catalogo']">Productos</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [routerLink]="['/blog']">Blog</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [routerLink]="['/nosotros']">Nosotros</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="#contacto">Contacto</a>
                    </li>
                    <li class="nav-item dropdown hlp">
                        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          Ayuda
                        </a>
                        <div class="dropdown-menu dmnu" aria-labelledby="navbarDropdown">
                            <a class="dropdown-item dpitm" (click)="openHelp('pasos')">Pasos para Comprar</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item dpitm" (click)="openHelp('formas')">Formas de Pago</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item dpitm" (click)="openHelp('envios')">Envíos y Entregas</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item dpitm" (click)="openHelp('cuenta')">Mi Cuenta</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item dpitm" (click)="openHelp('preguntas')">Preguntas Frecuentes</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item dpitm" [routerLink]="['/terminos']">Términos y Condiciones</a>
                        </div>
                    </li>
                </ul>
            </div>
        </nav>
    </div>
</div>

<div class="d-xs-block d-sm-block d-md-block d-lg-none d-xl-none animated fadeIn">
    <nav class="navbar navbar-expand-lg navbar-light bg-light menmovil">
        <a class="navbar-brand" href="#">
            <img src="../../../assets/img/logoTorreon.png" width="130" alt="" loading="lazy">
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav">
                <li class="nav-item active">
                    <a class="nav-link" [routerLink]="['/catalogo']">Inicio <span class="sr-only">(current)</span></a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['/catalogo']">Productos</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['/blog']">Blog</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['/nosotros']">Nosotros</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#contacto">Contacto</a>
                </li>
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Ayuda
                    </a>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <a class="dropdown-item" (click)="openHelp('pasos')">Pasos para Comprar</a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" (click)="openHelp('formas')">Formas de Pago</a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" (click)="openHelp('envios')">Envíos y Entregas</a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" (click)="openHelp('cuenta')">Mi Cuenta</a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" (click)="openHelp('preguntas')">Preguntas Frecuentes</a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item dpitm" [routerLink]="['/terminos']">Términos y Condiciones</a>
                      </div>
                </li>
            </ul>
            <form id="buscar" [formGroup]="searchForm" class="form-inline" (ngSubmit)="OnSearch(searchForm.value.palabra)">
                <input type="text" value="" class="form-control sch" placeholder="Ej...colágeno, artritis, huesos" formControlName="palabra" autocomplete="off" />
                <button type="submit" class="btn btn-light but"><i class="fa fa-search" aria-hidden="true"></i></button><br>
            </form>
            <div class="mt-2">
                <button class="car2" [routerLink]="['/solicitudes']" routerLinkActive="router-link-active">
                <i class="fa fa-shopping-cart" aria-hidden="true"></i>
                <span class="badge badge-warning intermitentesec">{{pedidos}}</span>
            </button>
            </div>
        </div>
    </nav>
</div>
